import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { TribunaleaAuthProvider } from "@tribunalea/auth/react";
import { RouterProvider, ToastProvider } from "@tribunalea/ui";
import App, { CIVITA_DEFAULT_PATH } from "./App.jsx";
import "@tribunalea/ui/styles.css";
import "./styles.css";

const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:4000";
const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const liveContent = (
  <RouterProvider defaultPath={CIVITA_DEFAULT_PATH}>
    <App authEnabled />
  </RouterProvider>
);
const demoContent = (
  <RouterProvider defaultPath={CIVITA_DEFAULT_PATH}>
    <App authEnabled={false} />
  </RouterProvider>
);

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ToastProvider>
      <TribunaleaAuthProvider
        publishableKey={clerkPublishableKey}
        apiUrl={apiUrl}
        demoFallback={demoContent}
      >
        {liveContent}
      </TribunaleaAuthProvider>
    </ToastProvider>
  </StrictMode>,
);
